import { Show } from '@rails/upload';
import { useFrame } from '@/frames/FrameContext';

const Upload = ({ upload }) => {
  /*
   * isSelected
   * multiple
   * select
   * selectAll
   * selected
   * selectedIds
   * setMultiple
   * toggle
   * unselect
   * unselectAll
   */
  const { toggle, select, isSelected, setMultiple } = useFrame();
  return (
    <div className='cursor-pointer'>
      <Show
        upload={upload}
        rotatable
        selected={isSelected(upload)}
        onClick={() => toggle(upload)}
        onLongPress={() => {
          setMultiple(true);
          select(upload);
        }}
        limit={200}
      />
    </div>
  );
};

export default Upload;
